var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconListenGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1743 15.1286C29.7619 9.90482 26.3252 0.488281 16.0151 0.488281H14.9154C4.60533 0.488281 1.16864 9.97355 0.756234 15.1286L0.6875 25.4387C0.6875 26.2635 1.37484 26.9508 2.19964 26.9508H6.66734C9.14176 26.9508 11.135 24.9575 11.135 22.4831V19.5276C11.135 17.0531 9.14176 15.0599 6.66734 15.0599H3.64306H3.57432C3.71179 14.0976 4.05546 11.6919 5.29267 9.21748C7.28595 5.23092 10.5164 3.1689 14.9154 3.1689H16.0151C25.5004 3.1689 27.15 12.9978 27.3562 15.1286H27.2875H24.3319C21.8575 15.1286 19.8642 17.1219 19.8642 19.5963V22.5518C19.8642 25.0263 21.8575 27.0196 24.3319 27.0196H28.7996C29.6245 27.0196 30.2431 26.3322 30.2431 25.5074L30.1743 15.1286Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListenGray);
export default __webpack_public_path__ + "static/media/icon_listen-gray.3a88fe9e02ad62324fa96b221e0b8104.svg";
export { ForwardRef as ReactComponent };